export interface TreePerson {
  id: string;
}
export interface TreeRelationship {
  fromPersonId: string;
  toPersonId: string;
  type: string;
}
export function layoutTree(
  people: TreePerson[],
  relationships: TreeRelationship[],
) {
  const ranks = new Map(people.map((p) => [p.id, 0]));
  // Keep partners on one generation where that agrees with the parent graph.
  // An unusual partner link spanning ancestry must not make ranks grow forever.
  for (const alignPartners of [true, false]) {
    for (const person of people) ranks.set(person.id, 0);
    let settled = false;
    for (let iteration = 0; iteration <= people.length; iteration++) {
      let changed = false;
      for (const edge of relationships) {
        if (!ranks.has(edge.fromPersonId) || !ranks.has(edge.toPersonId))
          continue;
        const from = ranks.get(edge.fromPersonId)!;
        const to = ranks.get(edge.toPersonId)!;
        if (edge.type === "partner") {
          if (alignPartners && from !== to) {
            ranks.set(edge.fromPersonId, Math.max(from, to));
            ranks.set(edge.toPersonId, Math.max(from, to));
            changed = true;
          }
        } else if (from + 1 > to) {
          ranks.set(edge.toPersonId, Math.min(people.length, from + 1));
          changed = true;
        }
      }
      if (!changed) {
        settled = true;
        break;
      }
    }
    if (settled) break;
  }
  const levels = new Map<number, string[]>();
  for (const person of people) {
    const rank = ranks.get(person.id) || 0;
    levels.set(rank, [...(levels.get(rank) || []), person.id]);
  }
  const width = Math.max(
    620,
    ...Array.from(levels.values()).map((row) => row.length * 170 + 80),
  );
  const height = Math.max(350, (Math.max(0, ...levels.keys()) + 1) * 200 + 100);
  const positions = new Map<string, { x: number; y: number }>();
  for (const [rank, row] of levels)
    row.forEach((id, index) =>
      positions.set(id, {
        x: width / 2 + (index - (row.length - 1) / 2) * 170,
        y: 75 + rank * 200,
      }),
    );
  return { positions, width, height };
}
